import "../../index45.css";
import { jsxs as s, Fragment as d, jsx as i } from "react/jsx-runtime";
import { useState as _, useRef as a, useEffect as E } from "react";
import { AlertLineIcon as N } from "@ifrc-go/icons";
import { i as m } from "../../type-BFTbooL7.js";
import { _ as x } from "../../cs-piwRuCFZ.js";
import R from "../Popup/index.js";
const h = "_input-error_1sxiz_1", y = "_pointer_1sxiz_14", r = {
  inputError: h,
  pointer: y
};
function v(c) {
  const {
    children: e,
    className: p,
    disabled: u
  } = c, [f, l] = _(!1), n = a(), t = a(null);
  return E(
    () => {
      if (m(t.current))
        return;
      const {
        current: {
          parentElement: o
        }
      } = t;
      m(o) || (n.current = o, l(!0));
    },
    []
  ), /* @__PURE__ */ s(d, { children: [
    !f && /* @__PURE__ */ i(
      "div",
      {
        className: r.tooltipDummy,
        ref: t
      }
    ),
    e && !u && /* @__PURE__ */ s(
      R,
      {
        className: x(r.inputError, p),
        pointerClassName: r.pointer,
        parentRef: n,
        children: [
          /* @__PURE__ */ i(N, { className: r.icon }),
          e
        ]
      }
    )
  ] });
}
export {
  v as default
};
